<template>
  <div>
    <!-- ─── Main Header ─────────────────────────────────── -->
    <header
      class="new-header"
      :class="{
        'header-hidden-mobile': (showResumeClinic && !loginModalOpen) || loginModalOpen,
        'header-over-modal': showResumeClinic && loginModalOpen,
        'search-active': searchActive,
      }"
    >
      <div class="main">
        <div class="head-div d-flex gap-3">
          <img
            id="hideinlaptop"
            @click="openMobileMenu()"
            src="../../assets/imgs/newhomepage/hamburger.svg"
            alt="Menu"
          />
          <img
            class="logo pointer"
            @click="handleLogoClick()"
            src="https://d33yrtc8qntbdn.cloudfront.net/Hire3xAssests/Website/Header/hire3x-logo.svg"
            alt="Hire3x Logo"
          />
        </div>
        <div :class="{ 'extra-div': searchActive }"></div>
        <!-- <div id="hideinmobile" class="
         font-inter fw-500 fs-16">
          Find Mentor
        </div> -->

        <!-- Expanded Search Container -->
        <div class="header-center-area">
          <!-- Tabs -->
          <div class="lap-pl-5 mob-w100">
            <div
              ref="searchTabsContainer"
              class="search-tabs-container"
              :class="{ 'is-active': searchActive }"
            >
              <div
                class="search-tab"
                :class="{ active: selectedTab == 'job' }"
                @click="selectTab('job')"
              >
                Jobs
              </div>
              <span class="divider">|</span>
              <div
                class="search-tab"
                :class="{ active: selectedTab == 'assessment' }"
                @click="selectTab('assessment')"
              >
                Assessments
              </div>
              <span class="divider">|</span>
              <div
                class="search-tab"
                :class="{ active: selectedTab == 'course' }"
                @click="selectTab('course')"
              >
                Courses
              </div>
            </div>
          </div>

          <!-- Search Bar -->
          <div
            ref="searchBarWrapper"
            class="search-bar-wrapper"
            :class="{ 'is-active': searchActive }"
          >
            <div class="d-flex gap-2 w-100">
              <img
                id="hideinlaptop"
                @click="searchActive = false"
                class="shadow"
                src="../../assets/imgs/newhomepage/search-back.svg"
                alt="Close Search"
              />
              <div class="header-search">
                <b-form-input
                  placeholder="Search..."
                  @focus="openSearchDropdown()"
                  @click="openSearchDropdown()"
                  :value="searchQuery"
                  @input="onSearchInput"
                  @keydown.enter="handleEnterSearch"
                  autocomplete="off"
                ></b-form-input>
                <img
                  src="../../assets/imgs/newhomepage/searchBar.svg"
                  alt="Search Icon"
                />
              </div>
            </div>

            <!-- Search Dropdown Content -->
            <SearchDropdown
              v-show="searchActive"
              :is-visible="searchActive"
              :selected-tab="selectedTab"
              :p-search-suggestion="searchSuggestion"
              :p-search-query="searchQuery"
              :p-is-searching="isSearchLoading"
              @close-modal="closeSearchDropdown"
              @explore-click="handleExploreClick"
              @explore-click-logged-out="handleLoggedOutExploreClick"
            />
          </div>
        </div>

        <!-- Overlay to close search dropdown -->
        <div
          class="search-overlay"
          v-if="searchActive"
          @click="searchActive = false"
        ></div>

        <!-- Mobile: search icon -->
        <div
          id="hideinlaptop"
          class="d-flex align-items-center"
          v-if="!searchActive"
        >
          <div @click="openMobileSearch()">
            <img src="../../assets/imgs/newhomepage/search.svg" alt="Search" />
          </div>
        </div>

        <!-- Desktop action buttons -->
        <div
          class="header-btns d-flex gap-16px align-items-center"
          id="hideinmobile"
        >
          <div class="pointer" @click="openNotificationPanel()">
            <img
              src="@/assets/imgs/newhomepage/Icons-bell-not.svg"
              alt="Notification"
            />
          </div>
          <b-button
            @click="$router.push('/home')"
            class="header-for-biz-btn w-170px"
          >
            <img
              src="../../assets/imgs/newhomepage/lucide_briefcase.svg"
              alt="For Business Icon"
            />
            For Business
          </b-button>
          <template v-if="isLoggedIn">
            <div class="position-relative user-avatar-container">
              <div class="user-avatar-btn pointer" @click="toggleUserDropdown">
                <img v-if="userInfoData && userInfoData.image" :src="userInfoData.image" alt="Avatar" class="user-avatar-img" />
                <span v-else>{{ (userInfoData && userInfoData.username && userInfoData.username !== 'Unknown') ? (userInfoData.username).charAt(0).toUpperCase() : 'G' }}</span>
              </div>
              <transition name="dropdown-fade">
                <div v-if="userDropdownOpen" class="user-profile-dropdown">
                  <div class="user-profile-banner-wrapper">
                    <div class="user-profile-banner">
                      <div class="banner-avatar">
                        <img v-if="userInfoData && userInfoData.image" :src="userInfoData.image" alt="Avatar" class="user-avatar-img"/>
                        <span v-else>{{ (userInfoData && userInfoData.username && userInfoData.username !== 'Unknown') ? userInfoData.username.charAt(0).toUpperCase() : 'G' }}</span>
                      </div>
                      <span class="banner-username">{{ (userInfoData && userInfoData.username && userInfoData.username !== 'Unknown') ? userInfoData.username : 'Guest User' }}</span>
                    </div>
                  </div>
                  <div class="user-dropdown-item" @click="goToDashboard">
                    <img src="../../assets/imgs/newhomepage/mi_home.svg" alt="Home" class="dropdown-icon" />
                    <span>Go to Dashboard</span>
                  </div>
                  <div class="dropdown-divider"></div>
                  <div class="user-dropdown-item logout-item" @click="confirmAndLogout">
                    <img src="../../assets/imgs/newhomepage/Logout.svg" alt="Logout" class="dropdown-icon logout-icon" />
                    <span>Log Out</span>
                  </div>
                </div>
              </transition>
            </div>
          </template>
          <b-button
            v-else
            @click="checkAndTriggerLoginModal"
            class="header-login-btn w-125px"
          >
            Login
            <img src="../../assets/imgs/newhomepage/round-arrow.svg" alt="" />
          </b-button>
        </div>
      </div>
    </header>

    <!-- ─── Notification Slide Panel ──────────────────────── -->
    <transition name="notif-slide">
      <div v-if="notifOpen" class="notif-panel">
        <div class="notif-panel-header">
          <span class="notif-panel-title">Notifications</span>
          <button class="notif-close-btn" @click="notifOpen = false">✕</button>
        </div>

        <div class="notif-list">
          <div v-for="(notif, i) in notifications" :key="i" class="notif-card">
            <div
              class="notif-card-body pointer"
              @click="handleNotifAction(notif)"
            >
              <img class="notif-avatar" :src="notif.avatar" :alt="notif.name" />
              <div class="notif-text">
                <p class="notif-name">{{ notif.name }}</p>
                <p class="notif-msg">{{ notif.message }}</p>
                <button
                  v-if="notif.cta"
                  class="notif-cta"
                  @click.stop="handleNotifAction(notif)"
                >
                  {{ notif.cta }}
                </button>
              </div>
            </div>
          </div>

          <div v-if="notifications.length === 0" class="notif-empty">
            You're all caught up! 🎉
          </div>
        </div>
      </div>
    </transition>

    <!-- Overlay to close notification panel -->
    <div
      v-if="notifOpen"
      class="notif-overlay"
      @click="notifOpen = false"
    ></div>

    <!-- ─── Mobile Menu Drawer ──────────────────────── -->
    <div class="mobile-drawer-menu" :class="{ 'is-open': isMobileMenuOpen }">
      <div class="drawer-header">
        <div class="d-flex align-items-center gap-2">
          <img
            @click="handleLogoClick"
            class="logo"
            src="https://d33yrtc8qntbdn.cloudfront.net/Hire3xAssests/Website/Header/hire3x-logo.svg"
            alt="Hire3x Logo"
          />
        </div>
        <button class="drawer-close" @click="isMobileMenuOpen = false">
          ✕
        </button>
      </div>

      <div class="drawer-scroll-area">
        <nav class="drawer-nav">
          <div
            class="drawer-link"
            @click="
              isLoggedIn
                ? handleExploreClick({ name: 'Interviews' })
                : handleLoggedOutExploreClick({ name: 'Interviews' })
            "
          >
            <div class="drawer-icon-placeholder">
              <img
                src="../../assets/imgs/newhomepage/scaredweb.webp"
                alt="Mock Interviews Icon"
                width="28px"
              />
            </div>
            Mock Interviews
          </div>
          <div
            class="drawer-link"
            @click="
              isLoggedIn
                ? handleExploreClick({ name: 'Fix Resume' })
                : handleLoggedOutExploreClick({ name: 'Fix Resume' })
            "
          >
            <div class="drawer-icon-placeholder">
              <img
                src="../../assets/imgs/newhomepage/shortlist4x.png"
                alt="Resume Clinic Icon"
                width="28px"
              />
            </div>
            Resume Clinic
          </div>
          <div
            class="drawer-link"
            @click="
              isLoggedIn
                ? handleExploreClick({ name: 'Assessment' })
                : handleLoggedOutExploreClick({ name: 'Assessment' })
            "
          >
            <div class="drawer-icon-placeholder">
              <img
                src="../../assets/imgs/newhomepage/cupweb.webp"
                alt="Mock Assessments Icon"
                width="28px"
              />
            </div>
            Mock Assessments
          </div>
          <div
            class="drawer-link"
            @click="
              isLoggedIn
                ? handleExploreClick({ name: 'Jobs' })
                : handleLoggedOutExploreClick({ name: 'Jobs' })
            "
          >
            <div class="drawer-icon-placeholder">
              <img
                src="../../assets/imgs/newhomepage/course-handweb.webp"
                alt="Find Jobs Icon"
                width="28px"
              />
            </div>
            Find Jobs
          </div>
          <div
            class="drawer-link"
            @click="
              isLoggedIn
                ? handleExploreClick({ name: 'Courses' })
                : handleLoggedOutExploreClick({ name: 'Courses' })
            "
          >
            <div class="drawer-icon-placeholder">
              <img
                src="../../assets/imgs/newhomepage/booksweb.webp"
                alt="Find Courses Icon"
                width="28px"
              />
            </div>
            Find Courses
          </div>
          <!-- <div
            class="drawer-link"
            @click="
              isLoggedIn
                ? handleExploreClick({ name: 'Mentor' })
                : handleLoggedOutExploreClick({ name: 'Mentor' })
            "
          >
            <div class="drawer-icon-placeholder">
              <img
                src="../../assets/imgs/newhomepage/s-find-mentor.svg"
                alt="Find Mentors Icon"
              />
            </div>
            Find Mentors
          </div> -->
        </nav>

        <div class="drawer-divider"></div>

        <nav class="drawer-nav">
          <div
            class="drawer-link"
            @click="
              isLoggedIn
                ? handleExploreClick({ name: 'Register' })
                : handleLoggedOutExploreClick({ name: 'Register' })
            "
          >
            <div class="drawer-icon-placeholder">
              <img
                src="../../assets/imgs/newhomepage/s-registerweb.webp"
                width="28px"
                alt="Register Icon"
              />
            </div>
            Register- As a Candidate
          </div>
          <div
            class="drawer-link"
            @click="
              isLoggedIn
                ? handleExploreClick({ name: 'Business' })
                : handleLoggedOutExploreClick({ name: 'Business' })
            "
          >
            <div class="drawer-icon-placeholder">
              <img
                src="../../assets/imgs/newhomepage/Preview.webp"
                width="28px"
                alt="Business Icon"
              />
            </div>
            Business- Request a Demo
          </div>
          <div class="drawer-link" @click="goToPlaystore()">
            <div class="drawer-icon-placeholder">
              <img
                src="@/assets/imgs/newhomepage/download-up.png"
                alt="Get App Icon"
                width="24px"
              />
            </div>
            Get our App
          </div>
        </nav>
      </div>

      <footer class="drawer-footer">
        <div @click="$router.push('/home')" class="mb-4">
          <div class="w-100">
            <img
              class="w-100"
              src="../../assets/imgs/newhomepage/s-bannerweb.webp"
              alt="App Promotional Banner"
            />
          </div>
        </div>
        <button
          v-if="!isLoggedIn"
          class="main-blue-btn w-100"
          @click="triggerRegisterModal()"
        >
          Get Started
        </button>
        <button
          class="drawer-logout-btn mt-2"
          @click="checkAndTriggerLoginModal"
        >
          {{ isLoggedIn ? "Log out" : "Login" }}
        </button>
        <!-- <button class="drawer-logout-btn mt-2">Log out</button> -->
      </footer>
    </div>

    <div
      v-show="isMobileMenuOpen"
      class="drawer-overlay"
      @click="isMobileMenuOpen = false"
    ></div>
    <ResumeClinic
      v-if="showResumeClinic"
      :showModal="showResumeClinic"
      @modalClose="modalClose"
      @openLoginModal="openLoginModal"
      @openLoginModalWithJobID="openLoginModalWithJobID"
    />
    <LogoutConfirmModal
      :visible="showLogoutModal"
      @confirm="confirmLogout"
      @cancel="cancelLogout"
    />
  </div>
</template>

<script>
import ResumeClinic from "../modalComponent/ResumeClinic.vue";
import LogoutConfirmModal from "../modalComponent/LogoutConfirmModal.vue";
import SearchDropdown from "./SearchDropdown.vue";
import globalSearchMixin from "@/utils/mixins/globalSearchMixin";
import config from "../../utils/config";
import EventBus from "@/utils/eventBus";
import { mapGetters } from "vuex";
import { openLoginModal } from "@/utils/helpers";
import headerMixin from "@/utils/mixins/headerMixin";
import heeraNotificationMixin from "@/utils/mixins/heeraNotificationMixin";

export default {
  name: "HeaderComponent",
  mixins: [globalSearchMixin, heeraNotificationMixin, headerMixin],
  skipRecentSearchRefresh: true,
  data() {
    return {
      loginModalOpen: false,
      userDropdownOpen: false,
      selectedTab: "job",
      isMobileMenuOpen: false,
      searchActive: false,
      showResumeClinic: false,
      showLogoutModal: false,
      searchQuery: "",
      searchSuggestion: [],
      exploreItems: [
        {
          name: "Resume",
          icon: require("../../assets/imgs/newhomepage/h-resume.svg"),
        },
        {
          name: "Interviews",
          icon: require("../../assets/imgs/newhomepage/h-interview.svg"),
        },
        {
          name: "Jobs",
          icon: require("../../assets/imgs/newhomepage/h-jobs.svg"),
        },
        {
          name: "Courses",
          icon: require("../../assets/imgs/newhomepage/h-courses.svg"),
        },
        {
          name: "Roadmap",
          icon: require("../../assets/imgs/newhomepage/h-roadmap.svg"),
        },
        {
          name: "Fix Resume",
          icon: require("../../assets/imgs/newhomepage/h-fix.svg"),
        },
        {
          name: "Assessment",
          icon: require("../../assets/imgs/newhomepage/h-assess.svg"),
        },
      ],
      config,
    };
  },

  components: {
    ResumeClinic,
    LogoutConfirmModal,
    SearchDropdown,
  },

  computed: {
    ...mapGetters({
      isLoggedIn: "userVUEX/getCandAccess",
      userData: "userVUEX/getUserProfileData",
    }),
    userInfoData() {
      return this.userData || {};
    }
  },
  watch: {
    searchActive(val) {
      if (val || this.notifOpen || this.isMobileMenuOpen) {
        document.body.style.overflow = "hidden";
      } else {
        document.body.style.overflow = "";
      }
      if (val) {
        document.body.classList.add("search-active");
      } else {
        document.body.classList.remove("search-active");
      }

      EventBus.$emit("header-search-state", val);
    },
    userDropdownOpen(val) {
      EventBus.$emit("user-dropdown-toggled", val);
    },

    isMobileMenuOpen(val) {
      if (val || this.searchActive || this.notifOpen) {
        document.body.style.overflow = "hidden";
      } else {
        document.body.style.overflow = "";
      }

      EventBus.$emit("mobile-menu-state", val);
    },
    showResumeClinic(val) {
      EventBus.$emit(val ? "resume-clinic-opened" : "resume-clinic-closed");
    },
    $route() {
      this.searchActive = false;
      this.searchQuery = "";
    },
  },
  created() {
    this.loadNotifications();
    EventBus.$on("heera-visited-updated", this.handleHeeraVisitedUpdated);
  },
  mounted() {
    this.onLoginModalOpened = () => {
      this.loginModalOpen = true;
    };
    this.onLoginModalClosed = () => {
      this.loginModalOpen = false;
    };
    this.onResumeClinicOpened = () => {
      this.showResumeClinic = true;
    };
    this.onCloseResumeClinic = () => {
      this.showResumeClinic = false;
    };

    EventBus.$on("open-login-modal", this.onLoginModalOpened);
    EventBus.$on("close-login-modal", this.onLoginModalClosed);
    EventBus.$on("resume-clinic-opened", this.onResumeClinicOpened);
    EventBus.$on("resume-clinic-closed", this.onCloseResumeClinic);
    EventBus.$emit("active-header-type", "new");

    this.onCloseMobileMenu = () => {
      this.isMobileMenuOpen = false;
    };
    this.onCloseHeaderSearch = () => {
      this.closeSearchDropdown();
    };
    this.onPageShow = (event) => {
      if (event.persisted) {
        this.searchActive = false;
        this.searchQuery = "";
      }
    };
    this.onHeeraNotificationOpened = () => {
      if (this.userDropdownOpen) {
        this.closeUserDropdown();
      }
    };
    EventBus.$on("close-mobile-menu", this.onCloseMobileMenu);
    EventBus.$on("close-header-search", this.onCloseHeaderSearch);
    EventBus.$on("close-resume-clinic", this.onCloseResumeClinic);
    EventBus.$on("heera-notification-opened", this.onHeeraNotificationOpened);
    document.addEventListener("mousedown", this.handleDocumentClick, true);
    window.addEventListener("pageshow", this.onPageShow);
    this.onWindowFocus = () => {
      this.loadNotifications();
      this.fetchAndUpdateUserProfile();
    };
    window.addEventListener("focus", this.onWindowFocus);

    this.fetchAndUpdateUserProfile();
  },
  beforeDestroy() {
    if (this.searchQueryTimer) {
      clearTimeout(this.searchQueryTimer);
    }
    EventBus.$off("resume-clinic-opened", this.onResumeClinicOpened);
    EventBus.$off("resume-clinic-closed", this.onCloseResumeClinic);
    EventBus.$off("open-login-modal", this.onLoginModalOpened);
    EventBus.$off("close-login-modal", this.onLoginModalClosed);
    EventBus.$off("close-mobile-menu", this.onCloseMobileMenu);
    EventBus.$off("close-header-search", this.onCloseHeaderSearch);
    EventBus.$off("close-resume-clinic", this.onCloseResumeClinic);
    EventBus.$off("heera-notification-opened", this.onHeeraNotificationOpened);
    document.removeEventListener("mousedown", this.handleDocumentClick, true);
    window.removeEventListener("pageshow", this.onPageShow);
    window.removeEventListener("focus", this.onWindowFocus);
    document.body.style.overflow = "";
    document.body.classList.remove("search-active");
    EventBus.$off("heera-visited-updated", this.handleHeeraVisitedUpdated);
  },
  methods: {
    toggleUserDropdown() {
      this.userDropdownOpen = !this.userDropdownOpen;
    },
    closeUserDropdown() {
      this.userDropdownOpen = false;
    },
    confirmAndLogout() {
      this.userDropdownOpen = false;
      this.showLogoutModal = true;
      EventBus.$emit("logout-modal-opened");
    },
    goToPlaystore() {
      window.location.href =
        "https://play.google.com/store/apps/details?id=com.hire3x.candidate";
    },
    openNotificationPanel() {
      this.closeSearchBeforeAction();
      this.notifOpen = true;
    },
    triggerRegisterModal() {
      this.closeSearchBeforeAction();
      if (this.isMobileMenuOpen) {
        this.isMobileMenuOpen = false;
      }
      openLoginModal({ mode: "register" });
    },
    checkAndTriggerLoginModal() {
      if (this.isLoggedIn) {
        this.showLogoutModal = true;
        EventBus.$emit("logout-modal-opened");
      } else {
        this.triggerLoginModal();
      }
    },
    async confirmLogout() {
      await this.$store.dispatch("userVUEX/LogOut");
      this.showLogoutModal = false;
      this.isMobileMenuOpen = false;
      EventBus.$emit("logout-modal-closed");
    },
    cancelLogout() {
      this.showLogoutModal = false;
      EventBus.$emit("logout-modal-closed");
    },
    async gotoRequest() {
      await this.pushAndScroll(
        {
          name: "RequestDemo",
        },
        "demo-container",
      );
    },
    async pushAndScroll(targetRoute, containerId) {
      if (!this.isSameRoute(targetRoute)) {
        await this.$router.push(targetRoute);
      }

      this.$nextTick(() => {
        this.scrollToContainerOrWindow(containerId);
      });
    },
    isSameRoute(targetRoute) {
      const resolved = this.$router.resolve(targetRoute).route;

      return (
        resolved.path === this.$route.path &&
        JSON.stringify(resolved.query || {}) ===
          JSON.stringify(this.$route.query || {})
      );
    },
    scrollToContainerOrWindow(containerId) {
      const el = document.getElementById(containerId);

      if (el) {
        el.scrollTo({
          top: 0,
          behavior: "smooth",
        });
      } else {
        window.scrollTo({
          top: 0,
          behavior: "smooth",
        });
      }
    },
    closeSearchBeforeAction() {
      this.closeSearchDropdown();
    },
    openMobileMenu() {
      if (this.isMobileMenuOpen) {
        this.isMobileMenuOpen = false;
        return;
      }

      if (this.notifOpen) {
        this.notifOpen = false;
      }

      if (this.loginModalOpen) {
        EventBus.$emit("close-login-modal");
      }
      this.isMobileMenuOpen = true;
    },
    openMobileSearch() {
      if (this.notifOpen) {
        this.notifOpen = false;
      }

      if (this.loginModalOpen) {
        EventBus.$emit("close-login-modal");
      }

      this.searchActive = true;
      this.selectedTab = "job";
      this.searchQuery = "";
    },
    openLoginModal(uuid) {
      this.closeSearchBeforeAction();
      this.uuid = uuid;
      this.$store.commit("userVUEX/setresumeClinicuid", uuid);
      openLoginModal({ /* hideBusiness: true */ });
    },
    openLoginModalWithJobID(jobId, uuid) {
      this.closeSearchBeforeAction();
      this.uuid = uuid;
      this.jobId = jobId;
      this.$store.commit("userVUEX/setresumeClinicuid", uuid);
      this.$store.commit("userVUEX/setresumeJobid", jobId);
      openLoginModal({ /* hideBusiness: true */ });
    },
    modalClose() {
      this.showResumeClinic = false;
    },
    showResumeClinicModal() {
      this.searchActive = false;
      this.notifOpen = false;
      this.isMobileMenuOpen = false;

      // Force remount if already mounted but internally closed.
      if (this.showResumeClinic) {
        this.showResumeClinic = false;
        this.$nextTick(() => {
          this.showResumeClinic = true;
        });
        return;
      }

      this.showResumeClinic = true;
    },
    clearRecentSearches() {
      this.recentSearches = [];
    },

    openSearchDropdown() {
      if (!this.searchActive) {
        this.selectedTab = "job";
        this.searchQuery = "";
      }
      this.searchActive = true;
    },
    selectTab(tab) {
      this.selectedTab = tab;
      this.searchQuery = "";
    },
    handleDocumentClick(event) {
      if (this.searchActive) {
        if (
          !this.$refs.searchBarWrapper?.contains(event.target) &&
          !this.$refs.searchTabsContainer?.contains(event.target)
        ) {
          this.closeSearchDropdown();
        }
      }

      if (this.userDropdownOpen) {
        const userAvatar = this.$el.querySelector('.user-avatar-container');
        if (userAvatar && !userAvatar.contains(event.target)) {
          this.closeUserDropdown();
        }
      }
    },
    closeSearchDropdown() {
      this.searchActive = false;
    },
    handleLoggedOutExploreClick(item) {
      this.searchActive = false;
      this.isMobileMenuOpen = false;
      switch (item.name) {
        case "Resume":
          openLoginModal({
            redirectUrl: `${this.config.candidateBase}/dashboard/?from=candidate`,
            // hideBusiness: true,
          });
          break;
        case "Interviews":
          this.scrollToSectionOrRedirect(
            "mock-interviews-sec",
            "/#mockinterviews",
          );
          break;
        case "Jobs":
          this.scrollToSectionOrRedirect("jobs-sec", "/#jobs");
          break;
        case "Courses":
          this.scrollToSectionOrRedirect("courses-sec", "/#courses");
          break;
        case "Roadmap":
          this.scrollToSectionOrRedirect(
            "mock-interviews-sec",
            "/#mockinterviews",
          );
          break;
        case "Assessment":
          this.scrollToSectionOrRedirect("assessments-sec", "/#assessments");
          break;
        case "Fix Resume":
          this.showResumeClinicModal();
          break;
        case "Mentor":
          openLoginModal();
          break;
        case "Register":
          openLoginModal({ mode: "register" });
          break;
        case "Business":
          this.gotoRequest();
          break;
      }
    },
    handleExploreClick(item) {
      this.searchActive = false;
      this.isMobileMenuOpen = false;
      switch (item.name) {
        case "Resume":
          openLoginModal({
            redirectUrl: `${this.config.candidateBase}/dashboard/?from=candidate`,
            // hideBusiness: true,
          });
          break;
        case "Interviews":
          window.open(
            this.config.candidateBase + "/interview?from=candidate",
            "_self",
          );
          break;
        case "Jobs":
          window.open(
            this.config.candidateBase + "/job/search?tab=hire&from=candidate",
            "_self",
          );
          break;
        case "Courses":
          window.open(this.config.trainingBase + "/marketplace", "_self");
          break;
        case "Roadmap":
          window.open(
            this.config.candidateBase + "/interview?from=candidate",
            "_self",
          );
          break;
        case "Assessment":
          window.open(
            this.config.candidateBase +
              "/assessment/marketplace?from=candidate",
            "_self",
          );
          break;
        case "Fix Resume":
          this.showResumeClinicModal();
          break;
        case "Register":
          openLoginModal({ mode: "register" });
          break;
        case "Business":
          this.gotoRequest();
          break;
      }
    },
    scrollToSectionOrRedirect(sectionId, hashPath) {
      const el = document.getElementById(sectionId);
      if (el) {
        el.scrollIntoView({ behavior: "smooth", block: "start" });
        if (window.history.pushState) {
          window.history.pushState(null, null, hashPath);
        } else {
          window.location.hash = hashPath.split("#")[1];
        }
      } else {
        window.open(this.config.websiteBase + hashPath, "_self");
      }
    },

    triggerLoginModal() {
      this.closeSearchBeforeAction();
      if (this.isMobileMenuOpen) {
        this.isMobileMenuOpen = false;
      }
      openLoginModal();
    },
    scrollToTop() {
      this.closeSearchBeforeAction();
      const container = document.querySelector('.main-new-container');
      if (container) {
        container.scrollTo({ top: 0, behavior: "smooth" });
      }
      window.scrollTo({ top: 0, behavior: "smooth" });
    },
    handleLogoClick() {
      if (this.loginModalOpen) {
        EventBus.$emit("close-login-modal");
      }
      this.showResumeClinic = false;
      EventBus.$emit("close-resume-clinic");
      EventBus.$emit("logo-clicked");

      if (this.$route.path !== "/") {
        this.$router.push("/");
      }
      this.isMobileMenuOpen = false;
      this.scrollToTop();
    },
  },
};
</script>

<style scoped>
/* Mobile Drawer Transitions */
.mobile-drawer-menu {
  position: fixed;
  top: 0;
  left: 0;
  width: 90%;
  max-width: 380px;
  height: 100dvh;
  background: #ffffff;
  z-index: 10000;
  display: flex;
  flex-direction: column;
  box-shadow: 2px 0 10px rgba(0, 0, 0, 0.1);
  transform: translateX(-100%);
  transition: transform 0.3s ease;
}

.mobile-drawer-menu.is-open {
  transform: translateX(0);
}

.drawer-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 24px;
  border-bottom: 1px solid #efefef;
}

.drawer-header .logo {
  height: 23px;
}

.drawer-close {
  background: none;
  border: none;
  font-size: 24px;
  color: #4a7eff;
  cursor: pointer;
  padding: 0;
}

.drawer-scroll-area {
  flex: 1;
  overflow-y: auto;
  height: auto;
  padding: 10px 0;
}

.drawer-nav {
  display: flex;
  flex-direction: column;
}

.drawer-link {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 14px 24px;
  font-family: "Inter", sans-serif;
  font-size: 16px;
  font-weight: 500;
  color: #000000;
  cursor: pointer;
  transition: background 0.2s;
}

.drawer-link:hover {
  background: #f8f9fa;
}

.drawer-icon-placeholder {
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* User can put svg inside drawer-icon-placeholder */
.drawer-icon-placeholder svg {
  width: 100%;
  height: 100%;
}

.drawer-divider {
  height: 1px;
  background: #f0f0f0;
  margin: 12px 0;
}

.drawer-footer {
  padding: 20px 24px;
}

.drawer-logout-btn {
  width: 100%;
  padding: 12px;
  border-radius: 25px;
  border: 1px solid #4A7EFF;
  background: #ffffff;
  color: #4A7EFF;
  font-weight: 500;
  font-size: 15px;
  cursor: pointer;
  transition: all 0.2s;
}

.drawer-logout-btn:hover {
  background: #4A7EFF;
  color: #ffffff;
}

.drawer-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.5);
  z-index: 9999;
}
@media (max-width: 1027px) {
  .header-hidden-mobile {
    display: none !important;
  }
}
.w-170px {
  width: 170px !important;
}
.w-125px {
  width: 125px !important;
}
.gap-16px {
  gap: 16px !important;
}
</style>
